import { Spinner } from '@marketertechnologies/ui-library';
import { RouterProvider, createRouter } from '@tanstack/react-router';
import { StrictMode, useEffect, useState } from 'react';
import ReactDOM from 'react-dom/client';

import './index.css';
import { routeTree } from './routeTree.gen';
import { setupI18n } from './utils/i18n';

const router = createRouter({
  routeTree,
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

function I18nGate({ children }: { children: React.ReactNode }) {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    setupI18n().finally(() => setReady(true));
  }, []);

  if (!ready) return <Spinner className="fixed inset-0 m-auto" />;

  return children;
}

const rootElement = document.getElementById('root')!;

if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);

  root.render(
    <StrictMode>
      <I18nGate>
        <RouterProvider router={router} />
      </I18nGate>
    </StrictMode>,
  );
}
